export const keyword_to_tsquery = (keyword: string) => {
  if (!keyword) return '';
  return keyword
    .trim()
    .split(/\s+/)
    .map(word => word + ':*')
    .join(' & ');
};

export const removeAccents = (str: string) => {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/Đ/g, 'D')
    .replace(/đ/g, 'd');
};
